import { MessageTag, ReplyVerifyingMessage } from "../general";

export class EditUserRequest extends ReplyVerifyingMessage {
    	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_EDIT_USER;
	public static tag : MessageTag = MessageTag.REQ_EDIT_USER;

  /**
   * Construct a new {@link UserEditRequest}.
   */
  constructor (
    public name: string,
    public phone: string,
    public country: string,
    public language: string
  )
  {
    super();
  }
}

export class EditOtherUserRequest extends ReplyVerifyingMessage {
  public tag : MessageTag = MessageTag.REQ_EDIT_OTHER_USER;
	public static tag : MessageTag = MessageTag.REQ_EDIT_OTHER_USER;
  
    /**
   * Construct a new {@link EditOtherUserRequest}.
   */
  constructor (
    public objectId: number,
    public name: string,
    public phone: string,
    public country: string,
    public language: string
  )
  {
    super();
  }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/edit-user-request.ts